import VehicleSectionRoot from './VehicleSection'
import useViewModel, { Props } from './useViewModel'

export default function VehicleSection(props: Props) {
  const viewModel = useViewModel(props)
  return <VehicleSectionRoot {...viewModel} />
}
